<template>
  <div style="padding-bottom: 10px">
    <div class="row">
      <div class="col-md-2">
        <p>
          История ИПР <i v-on:click="hide" class="tim-icons icon-minimal-up"></i>
        </p>
      </div>
      <div class="col-md-10">
        <p>
          Новый ИПР
          <i v-on:click="newCall" class="tim-icons icon-chat-33"></i>
        </p>
      </div>
    </div>
    <big-one :content="content" :type = "type" :a-page="true" :hide-pages="true" :page-limits="pageLimits" :tuning="false"
             :new-one="newOne"
             :default-sort="date" :default-sort-direction="false"
             @resetNew="newOne = null"></big-one>
  </div>
</template>
<script>

import {
  BaseInput,
  Card
} from "@/components/index";

import {sorter} from "@/services/utils";
import {authHeader} from "@/services/auth-header";
import {userService} from "@/services/user.service";

const iprDate = {header: "Дата выдачи", name: "date", show: true, sort: true, direction: true}
const iprUntilDate = {header: "Срок действия", name: "untilDate", show: true, sort: true, direction: true}
const iprSeries = {header: "Серия", name: "series", show: true};
const iprNumber = {header: "Номер", name: "number", show: true};
const iprGaveBy = {header: "Выдан", name: "gaveBy", show: true};

export default{
  name: 'client-call-history',
  components:{
    Card,
    BaseInput
  },
  props:{
    item: {}
  },
  data() {
    return {
      content: [iprDate, iprUntilDate, iprSeries, iprNumber, iprGaveBy],
      type: "ipr",
      pageLimits: {client: this.item.id},
      newOne: null
    };
  },
  methods: {
    hide() {
      this.$emit('hide');
    },
    newCall() {
      let currentTime = new Date().getTime();
      let object = {date: currentTime, nextDate: currentTime, client: this.item, id: 0};
      this.newOne = ({object: object, id: object.id, view: 'edit'});
    }
  }
}
</script>
<style>
</style>
